let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aJn5L")).then(() => parcelRequire('gFE3g'));